<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel120">Cards Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section  class="invoice-preview-wrapper" v-if="transactionDetails && !isEmpty(transactionDetails)">
              <div class="row invoice-preview">

                <div class="col-12" v-if="transactionDetails.card">
                  <div class="card invoice-preview-card">
                    <div class="card-body invoice-padding pb-0">
                      <!-- Header starts -->
                      <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <div>
                          <div class="logo-wrapper">
                            <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                          </div>
                          <div class="mt-md-0 mt-2 mb-2">
                            <h5 class="text-warning">
                              Card Holder:
                              <span class="invoice-number">{{transactionDetails.card?transactionDetails.card.card_holder_name:'N/A'}}</span>
                            </h5>
                            <h5 class="text-warning">
                              Card Number:
                              <span class="invoice-number">{{transactionDetails.card?transactionDetails.card.card_number:'N/A'}}</span>
                            </h5>
                          </div>
                          <h4 class="mb-4" >
                            Third Party Details
                          </h4>
                          <table class="table-responsive">
                            <tr v-for="(ItemValue,itemKey) in transactionDetails.card.details" class="force-content-single-line">
                              <td class="pr-5"><strong class="text-primary">{{itemKey}}</strong></td>
                              <td class="pr-5"><strong class="text-success">{{ItemValue}} </strong></td>
                            </tr>
                          </table>
                          <!--                      <p class="card-text mb-25 text-success"  v-for="(ItemValue,itemKey) in transactionDetails.card.details">-->
                          <!--                        <strong class="text-primary">{{itemKey}} : </strong>{{ItemValue}}-->
                          <!--                      </p>-->
                          <p class="card-text mb-25 text-primary" v-if="!transactionDetails.card && !transactionDetails.card.details">No Data Avalibale</p>
                        </div>
<!--                        <div class="mt-md-0 mt-2">-->
<!--                          <h5 class="invoice-title mb-0">-->
<!--                            Card Holder:-->
<!--                            <span class="invoice-number">{{transactionDetails.card?transactionDetails.card.card_holder_name:'N/A'}}</span>-->
<!--                          </h5>-->
<!--                          <h5 class="invoice-title mb-0">-->
<!--                            Card Number:-->
<!--                            <span class="invoice-number">{{transactionDetails.card?transactionDetails.card.card_number:'N/A'}}</span>-->
<!--                          </h5>-->
<!--                        </div>-->
                      </div>
                      <!-- Header ends -->
                    </div>




                  </div>
                </div>
                <div class="col-12 text-center mb-25 text-primary" v-else>No Data Avaliable</div>


              </div>
            </section>
            <div class="col-12 d-flex mb-1  justify-content-center" v-if="loader">
                <div class="spinner-border text-primary"></div>
              </div>
          </div>

        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'transactionId'],
  data() {
    return {
      transactionDetails: [],
      loader:false
    }
  },
  mounted() {
  },
  methods: {
    getTransactionsDetails() {
      let tData = this.$store.getters.getByKey(
          this.transactionId+"_t_details"
      );
      if (tData) {
        this.transactionDetails = tData?.data
        return
      }
      let data = {
        transactionId: this.transactionId,
        transactionDetail: 1
      }
      this.loader =true
      this.makeRequest("post", "v1/get-transaction", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                let responeDataToSave = {
                  data: responseData,
                  key:   this.transactionId+"_t_details"
                };
                this.$store.dispatch("setWithoutLocalStorage", responeDataToSave);
                this.transactionDetails = responseData
              }
            }
            this.loader =false
          }
      );
    }
  },
  watch:{
    show(val){
      if(val){
        this.getTransactionsDetails()

      }else{
        this.transactionDetails =[]
      }

    },

  }
}
</script>

<style scoped>

.force-content-single-line{
  white-space: nowrap;
}
/* Important part */
.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 80vh;
  overflow-y: auto;
}


/*--thank you pop starts here--*/
.thank-you-pop {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.thank-you-pop img {
  width: 76px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 25px;
}

.thank-you-pop h1 {
  font-size: 42px;
  margin-bottom: 25px;
  color: #5C5C5C;
}

.thank-you-pop p {
  font-size: 20px;
  margin-bottom: 27px;
  color: #5C5C5C;
}

.thank-you-pop h3.cupon-pop {
  font-size: 25px;
  margin-bottom: 40px;
  color: #222;
  display: inline-block;
  text-align: center;
  padding: 10px 20px;
  border: 2px dashed #222;
  clear: both;
  font-weight: normal;
}

.thank-you-pop h3.cupon-pop span {
  color: #03A9F4;
}

.thank-you-pop a {
  display: inline-block;
  margin: 0 auto;
  padding: 9px 20px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  background-color: #8BC34A;
  border-radius: 17px;
}

.thank-you-pop a i {
  margin-right: 5px;
  color: #fff;
}

#ignismyModal .modal-header {
  border: 0px;
}

/*--thank you pop ends here--*/

</style>

